<template>
  <section v-if="result" class="seo-text" :class="{ 'seo-text__active': isOpen }">
    <div class="seo-text__block" :class="{ 'seo-text__block__active': isOpen }">
      <SlideUpDown v-model="isOpen" :use-hidden="false" :class="{ 'seo-text__slide': isShowMore }">
        <DefContent ref="content" v-html="result" />
      </SlideUpDown>
    </div>

    <span
      v-if="isShowMore"
      class="seo-text__more"
      :class="{ 'seo-text__more--active': isOpen }"
      @click="isOpen = !isOpen"
    >
      <span v-if="isOpen">
        {{ messages.rollUp }}
      </span>
      <span v-else>
        {{ messages.readMore }}
      </span>
    </span>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import SlideUpDown from 'vue3-slide-up-down';
import DefContent from '@components/Def/DefContent/DefContent.vue';

export default {
  name: 'SeoText',
  components: {
    DefContent,
    SlideUpDown,
  },
  data() {
    return {
      isOpen: false,
      isShowMore: false,
    };
  },
  computed: {
    ...mapState({
      result: ({ results }) => results?.seoText,
      messages: ({ results }) => results?.messages,
    }),
  },
  mounted() {
    this.changeOutputMoreButton();

    window.addEventListener('resize', this.changeOutputMoreButton);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.changeOutputMoreButton);
  },
  methods: {
    changeOutputMoreButton() {
      if (this.$refs?.content?.$el) {
        const contentHeight = this.$refs.content?.$el?.offsetHeight;
        if (contentHeight > 140) {
          this.isShowMore = true;
          this.isOpen = false;
        } else {
          this.isOpen = true;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.seo-text {
  max-height: 200px;
  overflow: hidden;
  transition: 0.3s linear;
  padding: 30px 0;
  margin-bottom: 64px;
  position: relative;
  @include point-lg {
    text-align: center;
    max-width: 900px;
    margin: 0 auto 80px;
  }

  &__more {
    cursor: pointer;
    font-weight: 500;
    font-size: rem(16);
    text-decoration-line: underline;
    text-underline-position: under;
    transition: 0.2s linear color;

    &:hover {
      color: var(--color-dark-grey);
    }

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    padding: 30px 20px;
    background: linear-gradient(
      0deg,
      var(--background-color-thirternary) 0%,
      rgba(255, 255, 255, 0.6) 330%
    );

    display: flex;
    justify-content: center;

    &--active {
      position: static;
      background: var(--background-color-thirternary);
      padding: 30px 20px 0;
      @include point-md {
        padding: 30px 20px 0 0;
      }
    }

    span {
      color: #53595c;
      cursor: pointer;
      @include point-md {
        margin-left: 26px;
      }
    }
  }

  &__block {
    position: relative;
    max-height: 200px;
    overflow: hidden;
    transition: 0.3s linear;
    &__active {
      max-height: unset;
    }
  }

  &[is='SeoText'] {
    display: none;
  }

  &__slide {
    min-height: 140px;
  }
  &__active {
    max-height: unset;
  }
}
</style>
